<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />
    <link rel="stylesheet" type="text/css" href="/css/integrations.css" />

</svelte:head>

<script>

    import { createEventDispatcher } from "svelte";

    import {
        errorReasons,
        tripadvisorSearch
    } from "../api.svelte";


    const dispatch = createEventDispatcher();

    export let data = false;

    let query = '';
    let searchTimeout = 0;
    let searchResults = false;

    let isLoading = false;

    $: isLinked = () => {

        if (!data) return false;

        return Object.keys(data).includes('name');

    };


    let handler = () => {};

    let convertMutatedVowels = (input) => {

        let output = input;

        output = output.replace(/ä/g, "a");
        output = output.replace(/ü/g, "u");
        output = output.replace(/ö/g, "o");
        output = output.replace(/\u00df/g, "ss");

        return output;

    };

    let searchHandler = () => {

        clearTimeout(searchTimeout);

        searchTimeout = setTimeout(() => {

            if (query !== "") isLoading = true;
            searchTripadvisor();

        }, 1000);

    };

    let searchTripadvisor = () => {

        tripadvisorSearch(query).then((tripadvisorResults) => {

            if (tripadvisorResults['status'] !== 'success') {

                // TODO: Handle errore

                console.log(tripadvisorResults);
                return;

            }

            isLoading = false;

            let tripadvisorLocations = [];
            let splitQuery = query.split(' ');

            for (const item of Object.values(tripadvisorResults['results'])) {

                if (item['data_type'] !== 'LOCATION') {

                    continue;
                }

                let address = (item['address'] !== undefined)
                    ? item['address'] : (item['details']['address']
                        + ', ' + item['details']['parent_name']);

                let containsQueries = true;

                splitQuery.forEach((queryItem) => {

                    if (!(item['details']['name'] + address)
                        .toLowerCase().includes(convertMutatedVowels(queryItem.toLowerCase()))) {

                        containsQueries = false;
                    }

                });

                if (!containsQueries) {

                    continue;
                }

                let resultItem = {
                    'url': item['url'],
                    'name': item['details']['name'],
                    'address': address
                };

                if (tripadvisorLocations.includes(resultItem)) {

                    continue;
                }

                tripadvisorLocations.push(resultItem);

            }

            searchResults = tripadvisorLocations;

        });

    };

    let onClosed = () => {

        if (isLoading) return;

        dispatch('closed');
    };

    let onDeleted = () => {

        dispatch('deleted', {
            integration: 'tripadvisor'
        });

    };

    let onSelected = (name, address, url) => {

        searchResults = false;

        dispatch('selected', {
            name: name,
            address: address,
            url: url
        });

    };

</script>


<form
        on:submit|preventDefault={() => handler()}
        id="tripadvisorform" class="forms">

    <div class="form-header">

        <img src="/images/icons/integrations/tripadvisor.svg" />

        <span class="form-title">TripAdvisor</span>

    </div>

    {#if !isLinked()}

        <div class="input-title">

            Suchen Sie Ihren Standort auf TripAdvisor

        </div>

        <div class="search">

            <input
                    bind:value={query}
                    on:input={() => searchHandler()}
                    name="query"
                    type="text"
                    placeholder="Standort suchen ..." />

            {#if searchResults}

                <img
                        on:click={() => searchResults = false}
                        src="/images/icon-close.svg"
                        class="search-cancel" />

                <div id="search-results">

                    {#if searchResults.length < 1}

                        <div class="search-item">

                            <span class="item-name">Keine Ergebnisse.</span>

                        </div>

                    {/if}

                    {#each searchResults as item}

                        <div
                                class="search-item"
                                on:click={() => onSelected(item['name'], item['address'], item['url'])}>

                            <span class="item-name">{item['name']}</span>
                            <span class="item-address">{item['address']}</span>

                        </div>

                    {/each}

                </div>

            {/if}

        </div>

        <div class="integration-buttons single">

            <button
                    class={(isLoading) ? 'loading btn half' : 'btn half'}
                    on:click|preventDefault={() => onClosed()} >

                <span>Abschliessen</span>
                <img src="/images/button-loader.svg" />

            </button>

        </div>

    {:else}

        <div class="integration-view">

            <span id="title">{data['name']}</span>
            <span id="subtitle">{data['address']}</span>

        </div>

        <div class="integration-buttons">

            <button
                    class="btn danger half"
                    on:click|preventDefault={() => onDeleted()} >

                <span>Entfernen</span>

            </button>

            <button
                    class="btn half"
                    on:click|preventDefault={() => onClosed()} >

                <span>Abschliessen</span>

            </button>

        </div>

    {/if}

</form>


<style>

    .form-header img {
        width: 3.33vh;
        margin-right: 1.2vh;
    }

    .search {
        position: relative;
    }

    .search-cancel {
        position: absolute;
        top: 1.9vh;
        right: 1.5vh;
        cursor: pointer;
    }

    #tripadvisorform .input-title {
        margin-bottom: 0.92vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.48vh;
        text-align: left;
    }

    #tripadvisorform input {
        width: 31vh;
        padding: 1.42vh;
        font-size: 1.78vh;
    }

    #search-results {
        position: absolute;
        display: flex;
        flex-direction: column;
        width: 31vh;
        max-height: 20vh;
        padding: 1.42vh;
        margin-top: 0.3vh;
        overflow-y: scroll;
        z-index: 9;
        font-size: 1.5vh;
        font-family: 'Raleway', sans-serif;
        border-radius: 1vh;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
    }

    #search-results .search-item {
        display: flex;
        flex-direction: column;
        margin-bottom: 2vh;
        text-align: left;
        cursor: pointer;
    }

    #search-results .search-item:last-child {
        margin-bottom: 0;
    }

    .search-item .item-name {
        font-weight: 500;
    }

    .search-item .item-address {
        font-weight: 400;
        font-size: 1.4vh;
    }

</style>
